import React from 'react';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { Divider } from './components/Divider';
import { ProductSection } from './components/ProductSection';
import { ArtifactSection } from './components/ArtifactSection';
import { BonusSection } from './components/BonusSection';
import { ProofSection } from './components/ProofSection';
import { PricingSection } from './components/PricingSection';
import { FaqSection } from './components/FaqSection';
import { FooterCta } from './components/FooterCta';
import { StickyCta } from './components/StickyCta';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="max-w-[480px] mx-auto bg-cream min-h-screen relative shadow-2xl" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <div id="hero" data-id="element-2">
        <Hero data-id="element-3" />
      </div>
      <PainSection data-id="element-4" />
      <Divider data-id="element-5" />
      <ProductSection data-id="element-6" />
      <ArtifactSection data-id="element-7" />
      <BonusSection data-id="element-8" />
      <ProofSection data-id="element-9" />
      <PricingSection data-id="element-10" />
      <FaqSection data-id="element-11" />
      <FooterCta data-id="element-12" />
      <StickyCta data-id="element-13" />
    </div>;
}